/* MANAGE DAY OFF REQUEST */
Vue.component('managedayoffrequest',{
    template:'#managedayoffrequest-template',
    data:function(){
        return{
            project_number:0,
            date_start:'',
            date_end:'',
            type:'day_off',
            half_day:false,
            workers:[],
            activeWorkerId:'',
            workhours_off_this_year:0,
            recent_free_time_records:[],
            got_access:true,
            searchString:'',
            company_day_off_records:[]
        };
    },
    created:function(){

        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD',
                    locale: 'hu'
                });

                //activeInstance.getCalendarData();

            });
        },300);

        activeInstance = this;

        var id = $('#content_wrapper').attr('data-id');
        activeInstance.getAllWorkers();
        activeInstance.getUserRecordsForTheYear();

        setTimeout(function(){
            var $table = $('.fixed_header_table');
            $table.floatThead({
                top:70
            });
        },200);
    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            console.log(data);
            activeInstance.project_number = data.project_number;
        }
    },
    methods:{
        confirm:function(record){
            bootbox.confirm('Biztosan jóváhagyod a ' + record.date +' napra kért szabadságot '+record.first_name+' '+record.last_name+' számára?' , function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/day_off/confirm', {'id':record.id}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.getUserRecordsForTheYear();
                        successNotification('OK');
                        record.status="allowed";
                    }).bind(this);
                }
            });
        },
        reject:function(record){
            bootbox.confirm('Biztosan elutasítod a ' + record.date +' napra kért szabadságot '+record.first_name+' '+record.last_name+' számára?' , function(value){
                if(value==true){

                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/day_off/reject', {'id':record.id}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.getUserRecordsForTheYear();
                        successNotification('OK');
                        record.status="rejected";

                    }).bind(this);
                }
            });
        },
        getAllWorkers:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/worker/all').then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.workers = response.data;

            }).bind(this);
        },
        getUserRecordsForTheYear:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/all/time_records_belonging_to_a_division_leader').then(function(response){
                $('body').LoadingOverlay("hide");

                if(response.data.code != null)
                {
                    if(response.data.code==3000)
                    {
                        activeInstance.got_access=false;
                    }
                }
                total_workhours = 0;
                $.each(response.data,function(index,timerecord){
                    console.log(timerecord.duration);
                    total_workhours = parseInt(total_workhours) + parseInt(timerecord.duration);
                });
                activeInstance.recent_free_time_records = response.data;
                activeInstance.workhours_off_this_year = total_workhours;

                setTimeout(function(){
                    var $table = $('.fixed_header_table');
                    $table.floatThead({
                        top:70
                    });
                },200);

            }).bind(this);
        },
        send:function(){
            //$project_number,$user_id,$date_start,$date_end
            console.log('fetching timesheet data');

            bootbox.confirm('Minden adat helyes?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/request_day_off', {'date_start':activeInstance.date_start,'date_end':activeInstance.date_end,'type':activeInstance.type,'half_day':activeInstance.half_day,'confirmer_id':activeInstance.activeWorkerId}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.getUserRecordsForTheYear();
                        successNotification('OK');

                    }).bind(this);

                }
            });
        },
        humanize:function(text){
            switch (text) {
                case 'day_off':
                    return 'Szabadság';
                    break;
                case 'sick_leave':
                    return 'Betegszabadság';
                    break;
                case 'unconfirmed':
                    return 'Elbírálás alatt';
                    break;
                case 'confirmed':
                    return 'Jóváhagyott';
                    break;
                case 'rejected':
                    return 'Elutasított';
                    break;
                default:
                    break;
            }
        }

    }
});